import { inject } from "vue";
import axios, {} from "axios";
const PluginSymbol = Symbol('AxiosPlugin');
export const AxiosPlugin = {
    install: (app) => {
        const client = axios.create({
            headers: {
                "Content-type": "application/json",
            },
        });
        client.interceptors.response.use((response) => response, (error) => {
            if (axios.isCancel(error)) {
                console.log('Request canceled', error.message);
            }
            else {
                const toast = app.config.globalProperties.$toastService;
                if (error.isAxiosError && error.response?.status === 422) {
                    // 422 Unprocessable Entity
                }
                toast.error("Si è verificato un errore, riprovare.");
                throw error;
            }
        });
        app.provide(PluginSymbol, client);
        app.config.globalProperties.$axios = client;
    },
};
export function useAxios() {
    const plugin = inject(PluginSymbol);
    if (!plugin) {
        throw new Error(`Could not resolve ${PluginSymbol.description}`);
    }
    return plugin;
}
